import AnchorDialog from '@base/components/src/AnchorDialog';
import { MouseEventHandler } from 'react';

import ToFreeShippingsContent from './__components/ToFreeShippingsContent';
import styles from './ToFreeShippings.module.css';
import { ToFreeShippingsProps } from './types';
import clsx from 'clsx';
import config from 'config-base';

const ToFreeShippings = ({
  id,
  freeShippingMessage,
  freeShippingContent,
  linkTitle,
  subTitle,
}: Readonly<ToFreeShippingsProps>) =>
  freeShippingMessage !== '' ? (
    <div
      id={id}
      className={clsx(styles.toFreeShippings, {
        [styles.toFreeShippingsAGD]: config.brandCode === '2',
      })}
    >
      <div>
        <div className={styles.toFreeShippingsTypography}>
          {config.brandCode === '0' && (
            <img
              className={styles.cartIcon}
              src="/marketplace-static/images/icons/inclinedCartIcon.svg"
              alt="inclined cart icon"
              width={31}
              height={31}
            />
          )}
          <div
            className={clsx(styles.toFreeShippingsTypographyContainer, {
              [styles.toFreeShippingsTypographyContainerAGD]: config.brandCode === '2',
            })}
            dangerouslySetInnerHTML={{ __html: freeShippingMessage }}
          />
        </div>
        <span
          className={clsx(styles.toFreeShippingSubTitle, {
            [styles.toFreeShippingSubTitleAGD]: config.brandCode === '2',
          })}
        >
          {subTitle}
          <AnchorDialog
            className={freeShippingContent ? styles.modal : ''}
            contentClassName={freeShippingContent ? styles.content : styles.modalContent}
            showBottomButton={!!freeShippingContent}
            anchorContent={(open: MouseEventHandler<HTMLSpanElement> | undefined) => (
              <span data-testid={'to-free-shipping-link-trigger'} className={`${styles.toFreeShippinlink} link`} onClick={open}>
                {linkTitle}
              </span>
            )}
          >
            <ToFreeShippingsContent freeShippingsContent={freeShippingContent} />
          </AnchorDialog>
        </span>
      </div>
    </div>
  ) : null;

export default ToFreeShippings;
